<nz-skeleton [nzActive]="true" [nzLoading]="loading"></nz-skeleton>
<div *ngIf="lineUp && !loading" class="font-roboto-400 text-blue-o-50">
  <div
    nz-row
    *ngFor="let player of lineUp"
    class="border-b border-grey-5 py-3 min-h-[70px] items-center"
  >
    <div nz-col nzSpan="4">
      <div class="border border-grey-5 p-1 w-fit" *ngIf="player.player.logo">
        <img
          alt="player-logo"
          class="w-[60px] max-sm:w-[30px]"
          [src]="player.player.logo"
        />
      </div>
    </div>
    <div nz-col nzSpan="2">
      {{ player.shirt_number }}
    </div>
    <div nz-col nzSpan="2">
      <img
        alt="national_logo"
        class="w-[20px] max-sm:w-[15px]"
        [src]="player.player.national_logo.logo"
        *ngIf="player.player.national_logo"
      />
    </div>
    <div nz-col nzSpan="14">
      <div class="font-roboto-700 text-blue">
        {{ player.player.name }}
      </div>
      <div *ngIf="player.player.short_name">
        ({{ player.player.short_name }})
      </div>
    </div>
    <div nz-col nzSpan="2">
      <span *ngIf="player.player.positions[0]" class="text-11"
        >({{ player.player.positions[0] }})</span
      >
    </div>
  </div>
</div>

<app-no-result
  message="NotAvalaibleInformation"
  *ngIf="!lineUp && !loading"
></app-no-result>
